import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Catalogues from './pages/Catalogues'
import Sizes from './pages/Sizes'
import Contacts from './pages/Contacts'
import Enquiries from './pages/Enquiries'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="catalogues" element={<Catalogues />} />
        <Route path="sizes" element={<Sizes />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="enquiries" element={<Enquiries />} />
      </Route>
    </Routes>
  )
}

export default App
